<template>
  <SideSheet
    :is-open="showSideSheet"
    show-back-button
    position="right"
    content-size="md"
    @close="closeModal"
  >
    <div class="side-sheet">
      <NavBar>
        <template #left>
          <ButtonIconContextual
            icon="EF0030"
            label="Fechar"
            @click="closeModal"
          />
        </template>
      </NavBar>

      <div class="active-side-sheet">
        <div class="active-side-sheet__heading">
          <HeadingDisplay
            class="active-side-sheet__heading__title"
            :title="data?.title"
            size="small"
          />

          <BaseText
            class="active-side-sheet__heading__description"
            size="p4"
            :color="NebraskaColors.elementSecondary"
          >
            {{ data?.subtitle }}
          </BaseText>
        </div>

        <div class="active-side-sheet__content">
          <ContentDisplay
            footer-type="link"
            :blocks-length="1"
            :footer-label="data?.cardButton.title"
            @click="openPDF"
          >
            <template #content-block-1>
              <div class="active-side-sheet__content__text">
                <BaseText
                  size="p3"
                  :color="NebraskaColors.elementPrimary"
                  class="active-side-sheet__content__text__title"
                >
                  {{ data?.cardTitle }}
                </BaseText>
                <BaseText size="p4" :color="NebraskaColors.elementSecondary">
                  {{ data?.cardSubtitle }}
                </BaseText>
              </div>
            </template>
          </ContentDisplay>
        </div>
      </div>

      <ButtonContainer>
        <template #button-primary>
          <ButtonPrimary
            label="Aceitar"
            size="large"
            @click="openModalPassword"
          />
        </template>
      </ButtonContainer>
    </div>
  </SideSheet>
</template>

<script setup lang="ts">
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  BaseText,
  ButtonContainer,
  ButtonIconContextual,
  ButtonPrimary,
  ContentDisplay,
  HeadingDisplay,
  NavBar
} from '@warrenbrasil/nebraska-web';
import { SideSheet } from '@/modules/common/components/SideSheet';
import { Term } from '@/modules/trade/services/paid-custody';

const { data, showSideSheet } = defineProps<{
  data?: Term;
  showSideSheet: boolean;
}>();

const emit = defineEmits(['close', 'openPassword']);

const closeModal = () => {
  emit('close');
};

const openModalPassword = () => {
  emit('openPassword');
};

const openPDF = () => {
  window.open(data?.cardButton.link, '_blank');
};
</script>

<style lang="less" scoped>
.side-sheet {
  height: 100%;
  display: flex;
  flex-direction: column;
}

// TO-DO Remover quando atualizar o nebraska para v5.37.0
:deep(.navbar-container) {
  border-bottom: none;
}

:deep(.panel-content) {
  box-shadow: none !important;
}

.active-side-sheet {
  flex: 1;
  padding: @size-spacing-x600 @size-spacing-x1200 @size-spacing-x600
    @size-spacing-x1200;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: @size-spacing-x800;

  &__heading {
    display: flex;
    flex-direction: column;
    gap: @size-spacing-x400;

    &__title {
      max-width: 431px;
    }
    &__description {
      max-width: 387px;
    }
  }

  &__content {
    &__text {
      display: flex;
      flex-direction: column;
      gap: @size-spacing-x500;

      &__title {
        font-weight: 600;
      }
    }

    .content-display {
      border: none;
      background-color: @background-tertiary;
      padding: @size-spacing-x800 @size-spacing-x900;
    }

    :deep(.content-display__blocks) {
      margin: 0;
      padding-bottom: @size-spacing-x500;
    }

    :deep(.footer-spacing) {
      padding: @size-spacing-x400 0;
    }

    :deep(.footer-button__inner) {
      background-color: @background-tertiary;
    }

    :deep(.footer-button__inner p) {
      color: @element-primary !important;
      font-weight: 400;
    }
  }
}
</style>
